import { createFileRoute } from "@tanstack/react-router";

import UserProfilePage from "@/components/User/UserProfilePage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/account/profile")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/",
      },
      {
        label: i18n.t("navigation.account-settings"),
        icon: <Icon.USER_SETTINGS />,
        path: "/account/profile",
      },
    ];
    return { breadcrumbs };
  },
  component: UserProfilePage,
});
